import { useEffect, useState } from 'react';
import axios from 'axios';
import BASE_URL from './config';

const BoughtSharesTable = () => {
  const [boughtShares, setBoughtShares] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBoughtShares = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/bought-shares`);
      setBoughtShares(res.data.data);
    } catch (err) {
      console.error('Failed to fetch bought shares:', err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBoughtShares();
  }, []);

  return (
    <div className="card mt-4 mb-4">
      <div className="card-header bg-success text-white">📥 Bought Shares</div>
      <div className="card-body table-responsive">
        {loading ? (
          <div className="text-muted">Loading...</div>
        ) : boughtShares.length === 0 ? (
          <div className="text-muted">No shares bought yet.</div>
        ) : (
          <table className="table table-bordered table-sm table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Symbol</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Txn Type</th>
                <th>Status</th>
                <th>Placed At</th>
              </tr>
            </thead>
            <tbody>
              {boughtShares.map((order, idx) => (
                <tr key={order.id}>
                  <td>{idx + 1}</td>
                  <td>{order.symbol}</td>
                  <td>{order.quantity}</td>
                  <td>{order.price}</td>
                  <td>{order.transaction_type}</td>
                  <td>{order.status}</td>
                  <td>{new Date(order.placed_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default BoughtSharesTable;
